import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/kesariyalogo.webp";
import { MdArrowRightAlt, MdOutlineEmail } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { BsTelephone } from "react-icons/bs";
import googleplay from "../../assets/images/image 681 (1).webp";
import image1 from "../../assets/images/image 1.webp";
import image2 from "../../assets/images/image 2.webp";
import image3 from "../../assets/images/image 3.webp";
import image4 from "../../assets/images/image 4.webp";
import image5 from "../../assets/images/image 5.webp";
import image6 from "../../assets/images/image 6.webp";
import image7 from "../../assets/images/image 7.webp";
import image8 from "../../assets/images/image 8.webp";
import image9 from "../../assets/images/image 9.webp";
import image10 from "../../assets/images/image 10.webp";
import { RiInstagramLine } from "react-icons/ri";
import { FaYoutube, FaFacebook, FaPinterest } from "react-icons/fa";
import { saveAs } from "file-saver";
import { RiTwitterXFill } from "react-icons/ri";
import { ImMail3 } from "react-icons/im";
import { Tooltip } from "react-tooltip";
import { ADDRESS_API, EMAIL_API, FOOTER_API, HEADER_API, PHONE_API } from "../../config/config";
import { Button } from "react-bootstrap";
import axios from "axios";
export const Footer = () => {
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
  ];

  const [data, setData] = useState();
  const [socialIcons, setSocialIcons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const location = useLocation();
  const { pathname } = location;
  const pathSegments = pathname.split("/").filter(Boolean); // removes empty strings
  const dynamicCityFromURL = pathSegments.length >= 2 ? pathSegments[0] : "";
  const selectedLocation = dynamicCityFromURL.toLowerCase();

  // Get location from localStorage if URL doesn't have it
  const cityName = localStorage.getItem("city_name");
  const formattedCityName = cityName ? cityName.toLowerCase().replace(/\s+/g, "-").replace(/~/g, "-") : "";
  const countryName = localStorage.getItem("country_name")
    ? localStorage.getItem("country_name").toLowerCase().replace(/\s+/g, "-").replace(/~/g, "-")
    : "";

  // Determine final location - prioritize URL location over localStorage
  const finalLocation = selectedLocation ||
    (countryName === "india" ? formattedCityName : formattedCityName) || "";

  // Update storage data when location changes
  const [storageData, setStorageData] = useState({
    locationDynamic: "LOCATION_DY",
    locationReplace: finalLocation,
  });

  useEffect(() => {
    setStorageData({
      locationDynamic: "LOCATION_DY",
      locationReplace: finalLocation,
    });
  }, [pathname, finalLocation]);


  const fetchFooterData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(FOOTER_API);
      if (response.data.footer) {
        setData(response.data.footer);
      }

      if (response.data?.social_icons) {
        setSocialIcons(response.data.social_icons);
      }
      else {
        console.error("Unexpected API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadPDF = () => {
    const pdfUrl = `${data?.brochure_file}`;
    saveAs(pdfUrl, "dd12-13_0.pdf");
  };

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/about");
  };

  const RemoveMarketArea = () => {
    localStorage.removeItem("city_name");
    localStorage.removeItem("country_name");
  };

  const fetchheaderData = async () => {
    try {
      const response = await axios.post(HEADER_API);
      if (response.data && response.data.DATA) {
        setCategories(response.data.DATA);
      } else {
        setCategories([]);
      }
    } catch (error) {
      console.error("footer our product error", error);

    }
  };

  useEffect(() => {
    fetchFooterData();
    fetchheaderData();
  }, [])

  return (
    <div className="footer">
      <div className="container">
        <footer>
          <div className="row row-cols-1 row-cols-md-5 row-cols-sm-2 pt-3 them-font">
            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
              <a
                href="/"
                className="d-flex align-items-center text-decoration-none link-body-emphasis mb-3 mt-0"
              >
                <img
                  src={data?.footer_image}
                  alt="Kesaria Textile Company"
                  className="img-fluid"
                  loading="lazy"
                />
              </a>
              <p style={{ textAlign: "justify", fontSize: "15px" }} className="responsive-font-footer">
                {data?.footer_description}
              </p>

              <button
                className="btn btn-black-to-red-color-move btn-dark rounded-5"
                onClick={handleNavigate}
              >
                <span className="responsive-font-footer">Know More</span>
                <span>
                  <MdArrowRightAlt />
                </span>
              </button>
            </div>
            <div className="col-6 col-lg-2 col-md-4 company my-3">
              <div className="fs-4 fw-bold responsive-font-footer">Our Products</div>
              <ul className="flex-column nav" style={{ fontSize: "16px" }}>
                {categories.length > 0 &&
                  categories.map((category, index) => (
                    <li key={index} className="nav-item mb-2 responsive-font-footer">
                      <Link to={`/${storageData?.locationReplace ? `${storageData.locationReplace}/` : ""}${category.slug
                        ?.toString()
                        .trim()
                        .replace(/\s+/g, "-")
                        .replace(/~/g, "-")
                        .toLowerCase()}`} className="nav-link p-0 text-dark"
                        onClick={(e) => {
                          // Allow special key behavior (new tab etc.)
                          if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) {
                            return;
                          }
                          e.preventDefault();
                          const finalSlug = category?.slug
                            ?.toString()
                            .trim()
                            .replace(/\s+/g, "-")
                            .replace(/~/g, "-")
                            .toLowerCase();

                          const finalPath = storageData?.locationReplace
                            ? `/${storageData.locationReplace}/${finalSlug}`
                            : `/${finalSlug}`;

                          navigate(finalPath, {
                            state: {
                              from: "category",
                              id: category?.id,
                            },
                          });
                        }}
                      >
                        {category.name}
                      </Link>
                    </li>
                  ))}
              </ul>

            </div >
            <div className="col-6 col-lg-2 col-md-4 company my-3">
              <div className="fs-4 fw-bold responsive-font-footer"> Portal </div>
              <ul className="flex-column nav" style={{ fontSize: "16px" }}>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/blog/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Blogs
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/enquiry-ktc/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Enquire Now
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/career/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Careers
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/market-area/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Market Area
                  </Link>
                </li>

                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="/customer-review/"
                    className="nav-link p-0 text-dark"
                    onClick={RemoveMarketArea}
                  >
                    Customer Review
                  </Link>
                </li>
                {/* <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="/track-your-delivery/"
                    className="nav-link p-0 text-dark"
                    onClick={RemoveMarketArea}
                  >
                    Track Your delivery
                  </Link>
                </li> */}
                {/* <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/enquiry-ktc/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Enquire Now
                  </Link>
                </li> */}
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="/privacy-policy-2/"
                    className="nav-link p-0 text-dark"
                    onClick={RemoveMarketArea}
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="terms-condition/"
                    className="nav-link p-0 text-dark"
                    onClick={RemoveMarketArea}
                  >
                    Terms & Conditions
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/return-policy/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Return & Exchange
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/contact-us/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    Contact Us
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/faq/" className="nav-link p-0 text-dark" onClick={RemoveMarketArea}>
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 my-3">
              <h3 className="fs-4 fw-bold responsive-font-footer">Contact With Us</h3>
              <ul className="flex-column nav" style={{ fontSize: "16px" }}>
                <li className="d-flex nav-item mb-2 footer-info-text">
                  <IoLocationOutline className="fs-2 me-2" />
                  <div className="responsive-font-footer">
                    {data?.footer_address}
                  </div>
                </li>
                <li className="nav-item mb-2 footer-info-text responsive-font-footer">
                  <BsTelephone className="me-2" />
                  <a
                    href={`tel:${data?.footer_phone.replace(/\s+/g, "")}`}
                    className="text-decoration-none text-dark"
                  >
                    Phone: {data?.footer_phone}
                  </a>
                </li>


                <li className="nav-item mb-2 footer-info-text responsive-font-footer">
                  <MdOutlineEmail className="me-2" />
                  Email:{" "}
                  <a
                    href={data?.footer_email}
                    className="text-dark text-decoration-none"
                  >
                    {data?.footer_email}
                  </a>
                </li>
              </ul>
              <div className="ms-4 responsive-font-footer">
                Follow us on:
                <div className="d-flex flex-row gap-3 mt-2">
                  {socialIcons.map((icon, index) => (
                    <a key={index} href={icon.icon_link} target="_blank" rel="noopener noreferrer">
                      <img
                        src={icon.icon_image}
                        alt={icon.icon_name || "social"}
                        className="icon-hover"
                        data-tooltip-id="social-tooltip"
                        data-tooltip-content={icon.alt}
                        loading="lazy"
                        style={{ width: "1.6rem" }}
                      />
                    </a>
                  ))}
                </div>

              </div>
              <Tooltip id="social-tooltip" place="bottom" effect="solid" />
            </div>

            <div className="desktop-frn-btn col-lg-2 col-md-6 col-sm-12 d-flex flex-column align-items-center googleplay my-3">
              <img src={googleplay} alt="Google Play" className="google-play-btn img-fluid" loading="lazy" />
              <button
                className="btn-red-to-black-color-move brochurebtn mt-md-2"
                onClick={downloadPDF}
              >
                <span className="view-brochure-res">{data?.view_brochure}</span>
              </button>
              <Link to="/clothing-franchise/"
                className="custom-btn btn-12 btn-5 brochurebtn mt-md-2 franchiseBtn text-decoration-none"
              >
                <span className="view-brochure-res then-font">Kesaria Franchise</span><span className="view-brochure-res then-font">Kesaria Franchise</span>
              </Link>
            </div>

            <div className="d-sm-block d-md-none">
              <div className="d-flex flex-column align-items-center googleplay gap-0 gap-sm-2 my-3">
                <button
                  className="btn-red-to-black-color-move brochurebtn mt-md-2"
                  onClick={downloadPDF}
                >
                  <span className="view-brochure-res">{data?.view_brochure}</span>
                </button>
                <Link to="/clothing-franchise/"
                  className="custom-btn btn-12 btn-5 brochurebtn mt-md-2 franchiseBtn text-decoration-none"
                >
                  <span className="view-brochure-res then-font">Kesaria Franchise</span><span className="view-brochure-res then-font">Kesaria Franchise</span>
                </Link>
              </div>
              <div className="d-flex justify-content-center pb-3">
                <img src={googleplay} alt="Google Play" className="google-play-btn img-fluid" loading="lazy" />
              </div>
            </div>


          </div >
          <div className="d-flex flex-wrap row justify-content-center footercompanyimg">
            <div className="col-12 d-flex flex-wrap justify-content-center footer-images1">
              {images.map((e, i) => (
                <img
                  key={i}
                  src={e}
                  alt={`image ${i + 1}`}
                  className="bg-white m-1 p-2 rounded-2 footer-images icon-hover img-fluid"
                  style={{ width: "60px" }}
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </footer >
      </div >
    </div >
  );
};
